module.exports = __webpack_public_path__ + "static/startup_scaleup_of_the_year._award-ab0eb2e158c10c48212458fdc6301290.png";